var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductionManager = function SvgProductionManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M6.5 15.5a2 2 0 1 1 4 0m-4 0v-7a2 2 0 1 1 4 0v7m-4 0a2 2 0 1 0 4 0m7-7a2 2 0 1 1-4 0m4 0v7a2 2 0 1 1-4 0v-7m4 0a2 2 0 1 0-4 0M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgProductionManager;